var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.69043 22.1851C4.69092 22.4922 4.78174 22.793 4.95215 23.0489L5.78662 24.3033C5.92917 24.5177 6.12252 24.6936 6.34947 24.8152C6.57641 24.9369 6.82991 25.0005 7.0874 25.0005H10.1006C10.3581 25.0005 10.6116 24.9369 10.8385 24.8152C11.0655 24.6936 11.2588 24.5177 11.4014 24.3033L12.2358 23.0489C12.4062 22.793 12.4972 22.4925 12.4976 22.1851L12.4995 20.3125H4.68799L4.69043 22.1851ZM0 8.59379C0 10.7603 0.803223 12.7369 2.12695 14.2471C2.93359 15.1675 4.19531 17.0904 4.67627 18.7124C4.67822 18.7251 4.67969 18.7378 4.68164 18.7505H12.5059C12.5078 18.7378 12.5093 18.7256 12.5112 18.7124C12.9922 17.0904 14.2539 15.1675 15.0605 14.2471C16.3843 12.7369 17.1875 10.7603 17.1875 8.59379C17.1875 3.83842 13.3257 -0.0146068 8.56689 4.16298e-05C3.58594 0.0151783 0 4.05131 0 8.59379ZM8.59375 4.68754C6.43994 4.68754 4.6875 6.43998 4.6875 8.59379C4.6875 9.02543 4.33789 9.37504 3.90625 9.37504C3.47461 9.37504 3.125 9.02543 3.125 8.59379C3.125 5.57817 5.57812 3.12504 8.59375 3.12504C9.02539 3.12504 9.375 3.47465 9.375 3.90629C9.375 4.33793 9.02539 4.68754 8.59375 4.68754Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector-3.7cfcac60c4057fe794456d709ec9f397.svg";
export { ForwardRef as ReactComponent };